// Immagine del profilo: il server la restituisce come base64 grezzo (di solito SVG) oppure l'app la tiene già come data URL o
// percorso. Qui si decide cosa mettere in `src`; un valore vuoto o «null»/«undefined» scritto come testo (capita dal
// localStorage) significa «nessuna immagine».
export function srcAvatar(valore: unknown): string | null {
  if (valore === null || valore === undefined) return null;
  const testo = String(valore).trim();
  if (!testo || testo === "null" || testo === "undefined") return null;
  if (testo.startsWith("data:") || testo.startsWith("/") || testo.startsWith("http://") || testo.startsWith("https://")) return testo;
  return `data:image/svg+xml;base64,${testo}`;
}

// Iniziali per l'avatar senza immagine: cognome poi nome, in maiuscolo («Rossi Mario» → «RM»).
export function inizialiUtente(nome?: string | null, cognome?: string | null): string {
  return ((cognome ?? "").trim().charAt(0) + (nome ?? "").trim().charAt(0)).toUpperCase();
}
